module.exports = __webpack_public_path__ + "static/media/Avatar5.a82bc241.png";